import urls from '../constants/urls';

import { gatherErrors } from '../utils/errorHandling';
import {
  CHECKING_UNIQUENESS,
  CHECKING_UNIQUENESS_FAILED,
  UNIQUENESS,
} from './numbers';

export const UPDATE_EMAIL_FAILED = 'email/UPDATE_EMAIL_FAILED';
export const UPDATE_EMAIL_SUCCESS = 'email/UPDATE_EMAIL_SUCCESS';
export const UPDATING_EMAIL = 'email/UPDATING_EMAIL';

export const EMAIL_LOAD_FAILED = 'email/EMAIL_LOAD_FAILED';
export const EMAIL_LOAD_SUCCESS = 'email/EMAIL_LOAD_SUCCESS';
export const LOADING_EMAIL = 'email/LOADING_EMAIL';

const initialState = {
  email: null,

  updateErrors: {},

  failedLoading: false,
  failedSaving: false,

  isLoading: false,
  isSaving: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_EMAIL:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case EMAIL_LOAD_SUCCESS:
      return {
        ...state,
        email: action.payload.data.data,
        isLoading: false,
      };

    case EMAIL_LOAD_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    case UPDATING_EMAIL:
      return {
        ...state,
        updateErrors: {},
        failedSaving: false,
        isSaving: true,
      };

    case UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        updateErrors: {},
        isSaving: false,
      };

    case UPDATE_EMAIL_FAILED:
      return {
        ...state,
        updateErrors: gatherErrors(action.error, 'update_entry_failed'),
        failedSaving: true,
        isSaving: false,
      };

    default:
      return state;
  }
};

export const loadEmail = (hospitalId, emailId) => dispatch => {
  return dispatch({
    types: [LOADING_EMAIL, EMAIL_LOAD_SUCCESS, EMAIL_LOAD_FAILED],
    payload: {
      request: {
        url: urls.workspaces.emails.show(hospitalId, emailId),
      },
    },
  });
};

export const updateEmail = (hospitalId, emailId, params) => dispatch => {
  const emailParams = {
    title: params.title,
    value: params.value,
  };

  return dispatch({
    types: [UPDATING_EMAIL, UPDATE_EMAIL_SUCCESS, UPDATE_EMAIL_FAILED],
    payload: {
      request: {
        method: 'patch',
        url: urls.workspaces.emails.show(hospitalId, emailId),
        data: { email_address: emailParams },
      },
    },
  });
};

export const checkUniqueness = (hospitalId, emailId, params) => dispatch => {
  const emailParams = {
    title: params.title,
    value: params.value,
  };

  return dispatch({
    types: [CHECKING_UNIQUENESS, UNIQUENESS, CHECKING_UNIQUENESS_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.workspaces.emails.edit(hospitalId, emailId),
        params: emailParams,
      },
    },
  });
};
